const ThreadColorHeading = ({ compact = false }) => (
  <div style={{
    fontFamily: "Clash Grotesk",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: compact ? "2px 12px" : "0",
    fontSize: "11px",
    lineHeight: "16px",
    color: "#64748b",
  }}>
    <span style={{ fontWeight: 600 }}>
      Colors
    </span>
  </div>
);

export default ThreadColorHeading;
